import React from "react";
import "./css/Trips.css";
import Navbar from "../components/Navbar";
import SEO from "../components/SEO";
import Footer from "../components/Footer";
import locations from "../data/trips";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
export default function TripsPage() {
  const renderStars = (count) => {
    return "★".repeat(count) + "☆".repeat(5 - count);
  };

  return (
    <>
      <SEO
        title="Trips & Safari Destinations in Kenya | Joujo Safaris"
        description="Book unforgettable safari trips with Joujo Safaris. Explore the Masai Mara, Diani Beach, Lake Naivasha, Tsavo National Park, and Nairobi City. Luxury escapes, Big Five safaris, and cultural adventures await."
        url="https://joujosafaris.com/trips"
        image="https://www.joujosafaris.com/static/media/17.e27d8d7493ecdbc0378b.jpg"
        keywords="Kenya safari trips, safari destinations, Masai Mara tours, Diani Beach holidays, Lake Naivasha safari, Tsavo National Park trips, Nairobi travel packages, book safari Kenya"
        schema={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          name: "Trips & Safari Destinations - Joujo Safaris",
          description:
            "Discover curated safari destinations with Joujo Safaris. From luxury lodges to thrilling Big Five safaris, explore Masai Mara, Tsavo, Lake Naivasha, Diani, and Nairobi.",
          itemListElement: locations.map((loc, index) => ({
            "@type": "TouristTrip",
            position: index + 1,
            name: loc.name,
            description: loc.desc || `Safari trip to ${loc.name} with Joujo Safaris`,
            image: loc.image,
            url: `https://joujosafaris.com/explore/${encodeURIComponent(loc.name)}`,
            provider: {
              "@type": "TravelAgency",
              name: "Joujo Safaris",
              url: "https://joujosafaris.com",
              sameAs: [
                "https://x.com/SafarisJoujo",
                "https://www.facebook.com/J0ujosafaris/",
                "https://www.instagram.com/joujo_safaris/"
              ]
            }
          }))
        }}
      />

      <Navbar />
      <div
        className="about-main-title container"
        style={{ marginTop: "100px", marginBottom: "100px" }}
      >
        <h4 className="text-color">Safari Adventures</h4>
        <h5>Trips & Destinations</h5>
        <p>
          Explore Kenya’s most breathtaking safari destinations with Joujo
          Safaris. From the vast plains of the Masai Mara and the golden beaches
          of Diani, to the serene Lake Naivasha and the wild beauty of Tsavo —
          we design trips that are seamless, inspiring, and unforgettable.
        </p>
      </div>

      <div className="griddd-container container">
        {locations.map((loc, index) => (
          <div className="griddd-item" key={index}>
            <LazyLoadImage
                                                      alt={loc.name}
                                                      src={loc.image}
                                                      effect="blur"
                                                    />
            <div className="bg-daark"></div>
            <div className="overlayd">
              <h3>{loc.name}</h3>
              <div>
                <p>{renderStars(loc.rating)}</p>
              </div>
              <a
                href={`/explore/${encodeURIComponent(loc.name)}`}
                className="btn"
              >
                Book Now
              </a>
            </div>
          </div>
        ))}
      </div>
      <div style={{ marginBottom: "100px" }}></div>
      <Footer />
    </>
  );
}
